import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ExpandIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 16.5 16.5"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 16.5)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
    >
      <path d="M5.75 15.75h-5v-5M10.75.75h5v5" strokeLinecap="round" />
      <path d="m1.75 15 13.5-13.5" />
    </SVG>
  );
};
